import { RouteConfig } from '../../../../routing/types'

export type PathArgs = any[]

const ROUTE: RouteConfig<PathArgs> = {
  name: 'membership-update',
  path: () => '/membership/update',
  type: 'private',
}

export default ROUTE
